import {
    ChevronDownMedium,
    ChevronUpMedium
} from '@zoopla-eng/zds-components/icons';
import { useEffect, useRef, useState, useMemo } from 'react';
import { onDocumentClick } from '../utils/onDocumentClick';
import {
    SelectGroupIcon,
    selectGroupButtonStyles,
    selectGroupValueStyles,
    selectGroupStyles,
    SelectGroupDropdown
} from './SelectGroup.styles.css';
import { Box } from '@zoopla-eng/zds-components/box';
import { Label } from './Label';

type SelectGroupProps = {
    title: string;
    value: string;
    align?: 'left' | 'right';
    disabled?: boolean;
    children: React.ReactNode;
};

export const SelectGroup: React.FC<SelectGroupProps> = ({
    title,
    value,
    align = 'left',
    disabled = false,
    children
}) => {
    const [isActive, setIsActive] = useState(false);
    const rootNode = useRef<HTMLDivElement>(null);

    const toggle = () => {
        setIsActive(!isActive);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(
        onDocumentClick((event: globalThis.MouseEvent) => {
            if (
                rootNode.current &&
                event.target instanceof Node &&
                rootNode.current.contains(event.target)
            ) {
                return;
            }

            setIsActive(false);
        }),
        []
    );

    const selectGroupId = useMemo(
        () => `select-group-${title.toLocaleLowerCase().replace(' ', '-')}`,
        [title]
    );

    return (
        <Box
            display="flex"
            flexDirection="column"
            rowGap="S100"
            flex={1}
            position="relative"
            className={selectGroupStyles}
            ref={rootNode}
        >
            <Label htmlFor={selectGroupId} onClick={toggle}>
                {title}
            </Label>
            <button
                id={selectGroupId}
                className={selectGroupButtonStyles()}
                onClick={toggle}
                disabled={disabled}
                aria-expanded={isActive}
            >
                <span className={selectGroupValueStyles}>{value}</span>
                <div className={SelectGroupIcon} aria-hidden>
                    {isActive ? <ChevronUpMedium /> : <ChevronDownMedium />}
                </div>
            </button>
            <div className={SelectGroupDropdown({ isActive, align })}>
                {children}
            </div>
        </Box>
    );
};
